import { Box, Typography } from '@mui/material';
import TimeZoneSelector from './TimeZoneSelector';
import { UserForm } from './UserForm';
import { ProfilePictureUpload } from './ProfilePictureUpload';
import { useUserStateContext } from '@/shared/components/UserStateProvider';
import { useSnackbar } from 'notistack';

const AccountInfoPage = () => {
  const snackbar = useSnackbar();

  const {
    userProfile,
    actions: { updateName },
  } = useUserStateContext();

  const handleUpdateUser = async (firstName: string, lastName: string) => {
    await updateName(firstName, lastName);
    snackbar.enqueueSnackbar('User info updated', { variant: 'success' });
  };

  return (
    <>
      <Box sx={{ p: 2 }}>
        <Typography sx={{ mb: 5 }} variant="body1">
          Update User Info
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 2 }}>
            <ProfilePictureUpload
              profilePicturePath={userProfile?.profilePicturePath}
              firstName={userProfile?.firstName}
              lastName={userProfile?.lastName}
              onSuccess={() =>
                snackbar.enqueueSnackbar('Profile picture updated', { variant: 'success' })
              }
              onDelete={() =>
                snackbar.enqueueSnackbar('Profile picture removed', { variant: 'success' })
              }
            />
          <UserForm
            initialFirstName={userProfile?.firstName}
            initialLastName={userProfile?.lastName}
            onSubmit={handleUpdateUser}
          />
        </Box>
      </Box>

      <Box sx={{ p: 2 }}>
        <Typography sx={{ mb: 5 }} variant="body1">
          Timezone Settings
        </Typography>
        <TimeZoneSelector />

      </Box>
    </>
  );
};

export default AccountInfoPage;
